export default __webpack_public_path__ + "static/media/img5.b38d1c33.PNG";